export default "__VITE_ASSET__DqFrm64Y__"